module.exports = __webpack_public_path__ + "img/850.7e8953c8.png";